import React from 'react';

const AutocompleteVille = ({handleSearch, data, selectItem, isLoading, listHide}) => {
    let className="input-group input-search position-relative me-3";
    if(isLoading) className+=" is-loading";

    let className2="form-control bg-light ps-5 rounded-pill border-2 position-relative z-0";
    if(data.length && data.length > 0 && listHide==false) className2+=" is-open";

    let classNameList="list";
    if(listHide) classNameList +=" d-none";


    return (
        <div className={className}>
            <input onChange={handleSearch} type="text" className={className2} placeholder="Trouver une ville, un village" id="search" />
            {data.length > 0 && (
                <div className={classNameList}>
                    {data.map(object => (
                        <div
                            key={object.id}
                            id={object.id}
                            onClick={() => selectItem(object)}
                            className="list-item" dangerouslySetInnerHTML={{__html: object.nom + "<span>"+object.insee_com+"</span>"}}>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default AutocompleteVille;